import React from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import TopNavBar from "../../components/TopNavBar";
import { useNavigate, useSearchParams } from "react-router-dom";

const CheckInboxPage = () => {
  const theme = useTheme();
  const [urlParams] = useSearchParams();
  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <Container maxWidth={isLargeScreen ? "md" : false}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: 1,
        }}
        maxWidth={theme.breakpoints.values.md}
      >
        <TopNavBar showBackArrow={false} />
      </Box>
      <Box
        sx={{
          // View Height - TopNavBar height - BottomNavBar padding
          minHeight: "calc(100vh - 96px - 5rem)",
          background: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: 2,
        }}
      >
        <Card
          sx={{
            backgroundColor: "#00169E",
            color: "white",
            borderRadius: 4,
            maxWidth: 400,
            width: "100%",
            textAlign: "center",
            boxShadow: 10,
            justifyContent: "center",
            pt: 2,
            pb: 2,
          }}
        >
          <CardContent>
            <Avatar
              sx={{
                bgcolor: "#3b82f6",
                mx: "auto",
                mt: 2,
                mb: 2,
                width: 60,
                height: 60,
              }}
            >
              <EmailIcon fontSize="medium" />
            </Avatar>
            <Typography variant="h5" component="h2" gutterBottom>
              Check your inbox
            </Typography>
            <Typography
              variant="body2"
              color="white"
              sx={{ whiteSpace: "pre-line" }}
            >
              {`We sent you an email with your account information.
              Please be sure to check your spam folder too.`}
            </Typography>
            <Button
              variant={"contained"}
              sx={{
                mt: "3rem",
                whiteSpace: "pre-line",
                backgroundColor: "white",
              }}
              onClick={() => {
                navigate(`/account/login?${urlParams.toString()}`, {
                  replace: true,
                });
                navigate(0); //Force refresh
              }}
            >
              Or proceed to login
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default CheckInboxPage;
